import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SidebarServiceRequest } from '../sidebar.types';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private showRequestSubj = new Subject<SidebarServiceRequest>();
  showRequest$: Observable<SidebarServiceRequest> =
    this.showRequestSubj.asObservable();

  show(show: boolean) {
    this.showRequestSubj.next(SidebarServiceRequest.show(show));
  }

  toggle() {
    this.showRequestSubj.next(SidebarServiceRequest.toggle());
  }
}
